// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 连接器 枚举类
 * 连接器
 */
export enum EnumConnector {
  /** 并且 : 并且 */
  And = 1,
  /** 或 : 或 */
  Or = 2
}

/**
 * 连接器 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumConnectorMD {
  private static items = [
    new EnumItemMD('And', 1, '并且', '并且'),
    new EnumItemMD('Or', 2, '或', '或')
  ];

  static getItem(enumItem: EnumConnector) {
    return this.items.find(item => item.name === EnumConnector[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
